import { make as EnrichedTextBlock } from '../components/enrichedTextSection/EnrichedTextSection.bs';

import { tVariantSmartCard } from 'api/graphql/StoreContentContentType/Gql__StoreContent__Decoder.gen';
import SmartCardHeroSection from 'components/library/smartCardHeroSection';

import { Maybe } from 'models/types';
import { t as SmartCardHeroBlock_t } from 'api/graphql/SmartCardHeroBlock/Gql__SmartCardHeroBlock__Decoder.gen';
import { t as EnrichedTextBlock_t } from 'api/graphql/EnrichedTextBlock/Gql__EnrichedTextBlock__Decoder.gen';

export enum ContentBlockName {
  EnrichedTextBlock = 'EnrichedTextBlock',
  SmartCardHeroBlock = 'SmartCardHeroBlock',
}

export const getEnrichedTextSection = (storeContent: tVariantSmartCard[]) => {
  const data = storeContent.find(({ NAME }) => NAME === ContentBlockName.EnrichedTextBlock) as Maybe<{
    NAME: string;
    VAL: EnrichedTextBlock_t;
  }>;

  return data ? <EnrichedTextBlock block={data.VAL} wallOfCards={true} /> : null;
};

export const getSmartCardHeroSection = (storeContent: tVariantSmartCard[]) => {
  const data = storeContent.find(({ NAME }) => NAME === ContentBlockName.SmartCardHeroBlock) as Maybe<{
    NAME: string;
    VAL: SmartCardHeroBlock_t;
  }>;

  return data ? <SmartCardHeroSection block={data.VAL} /> : null;
};
